import { useEffect,useState, useRef} from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.css';
import TaskListLoader from './TaskListLoader';
import useApi from '../../../services/useApi';
import { useRecoilState } from 'recoil';
import { selectedBaseModelState, selectedModelState,namespaceState,taskListFilterState} from '../../../recoil/atoms';
import getTags from "../../../utils/getTags";
import getUsername from "../../../utils/getUsername";
import ModelListRow from "./ModelListRow";

export default function ModelList({className,filter, keyword}) {
  const [taskListFilter,setTaskListFilter]=useState({
    isFilteredUserId:false,
    sortBy:"createdTime",
    ascending:false,
    itemPerPage:20,
    pageNum:1,
  });
  const [listData,setListData] = useState([]);
  const [listCount,setListCount]=useState();
  const [listLoading, setListLoading] = useState(true);
  const [totalPage,setTotalPage]=useState(0);
  const [pageEdge,setPageEdge]=useState("none");
  const pageItemCount=3;
  const pageRange = Math.floor(pageItemCount / 2);
  const [selectedBaseModel, setSelectedBaseModel] = useRecoilState(selectedBaseModelState);
  const [selectedModel, setSelectedModel] = useRecoilState(selectedModelState);
  const [nsState,setNsState]=useRecoilState(namespaceState);
  const userId=JSON.parse(localStorage.getItem("account")).id;

  const cancelToken = axios.CancelToken;
  const cancelApi = useRef();

  useEffect(() => {
    cancelApi.current = cancelToken.source();
  }, [])

  useEffect(() => {
    getModelList();
  }, [filter, taskListFilter])

  useEffect( () => {
    handlePageNationBar(taskListFilter.pageNum);
  }, [totalPage]);

  const filterKeyword = (model) => {

    if(!keyword) {
      return true;
    }
    const searchKeyword  = keyword.toLowerCase();
    if(
        toLowerCase(model.name).includes(searchKeyword) ||
        toLowerCase(model.nameAlias).includes(searchKeyword) ||
        toLowerCase(model.dataset).includes(searchKeyword) ||
        toLowerCase(model.description).includes(searchKeyword) ||
        toLowerCase(getUsername(model.userMail)).includes(searchKeyword) ||
        toLowerCase(getTags(model.userTags,
            model.autoTags, 100, keyword)).includes(searchKeyword)
    ) {
      return true;
    }
    return false;
  }
  const toLowerCase = (str) => {
    if(!str)
      return ""
    return str.toLowerCase();
  }

  const getModelList = () => {

    cancelApi.current.cancel("Api Cancel");
    cancelApi.current = cancelToken.source();
    setListLoading(true);
    setListData([]);
    useApi.post('/ngp/modelreg/mm/model/v1/search', filter, {
      cancelToken: cancelApi.current.token
    })
    .then((res) => {
      setListData(res.data.items);
      setListCount(res.data.total);
      setTotalPage(res.data.totalPages);
      setListLoading(false);
    })
    .catch((e) => {
      if(axios.isCancel(e)) {
        console.log("request canceled", e.message);
      } else {
        console.log(e);
      }
    })
  }

  const handlePageNationBar = (nextPage) => {
    if(nextPage >= 1 && nextPage <= totalPage) {

      if (nextPage - (pageRange + 1) > 1) {
        setPageEdge("right");
        if (nextPage + (pageRange + 1) < totalPage) {
          setPageEdge("both");
        }
      } else if (nextPage + (pageRange + 1) < totalPage) {
        setPageEdge("left");
      } else {
        setPageEdge("none");
      }


      if(nextPage !== taskListFilter.pageNum) {
        setTaskListFilter((prev)=>({
          ...prev,
          "pageNum": nextPage,
        }))
      }
    }
  }

  const handlePagePrev=()=>{
    handlePageNationBar(taskListFilter.pageNum - 1);
  }

  const handlePageNext=()=>{
    handlePageNationBar(taskListFilter.pageNum + 1);
  }

  const handlePage=(value)=>{
    handlePageNationBar(Number(value));
  }

  const LoopTaskListLoader = () => {
    const newArr = [];
    for (let i = 0; i < 19; i++) {
      newArr.push(<TaskListLoader />);
    }
    return newArr;
  };

  const navigate = useNavigate();
  const handleNavigation = (newRoute,data) => {
    useApi.get('/ngp/modelreg/mm/model/v1/model?modelId='+data.modelId+'&namespaceId='+nsState.id+'&userId='+userId)
    .then((res) => {
      setSelectedBaseModel(res.data)
      setSelectedModel(res.data)
      if (!document.startViewTransition) {
        return navigate(newRoute);
      } else {
        return document.startViewTransition(() => {
          navigate(newRoute);
        });
      }
    })
  };

  return (
      <div className={`${styles["taskList-wrap"]} ${className}`}>
        <div className={styles["taskList-body"]}>
          <div className={styles["taskList-table-wrap"]}>
            <table className={styles["taskList-table"]}>
              <colgroup>
                <col width="10%"/>
                <col width="12%"/>
                <col width="10%"/>
                <col width="8%"/>
                <col width="10%"/>
                <col width="18%"/>
                <col width="22%"/>
                <col width="8%"/>
              </colgroup>
              <thead className={styles["table-head"]}>
              <tr className={styles["table-head-row"]}>
                <th>Name</th>
                <th>Alias</th>
                <th>dataset</th>
                <th>Size</th>
                <th>User</th>
                <th>Description</th>
                <th>Tags</th>
                <th>Status</th>
              </tr>
              </thead>
              <tbody className={styles["table-body"]} style={{textAlign: "center"}}>
              { listLoading ?
                  <>{LoopTaskListLoader()}</>
                  :
              listData.filter(model => filterKeyword(model)).map((m, index) =>
                  <ModelListRow 
                  model={m} 
                  keyword={keyword}
                  onClick={()=>handleNavigation("/model-detail",m)}
                  />
              )}
              </tbody>
            </table>
          </div>
          {listCount!==0&&
          <div className={styles['pagination']}>
            <button className={styles['pagination-prev']} onClick={handlePagePrev}>&lt;</button>
            <div className={styles['pagination-body']}>
              {listCount && <>
                <span className={`${styles['pagination-number']} 
                ${taskListFilter.pageNum== 1 && styles['pagination-number-on']}`}
                      onClick={(e)=>handlePage(e.target.innerText)}>
                  1</span>
                <div className={`
                  ${styles['pagination-line']} 
                  ${pageEdge=="right" && styles['pagination-line-on']}
                  ${pageEdge=="both" && styles['pagination-line-mini']}
                `}></div>
                {Array.from({length:pageItemCount},(_,index)=>
                    (taskListFilter.pageNum + index - pageRange > 1 && taskListFilter.pageNum + index - pageRange < totalPage ) &&
                    <span className={`${styles['pagination-number']} ${index == pageRange && styles['pagination-number-on']}`}
                          onClick={(e)=>handlePage(e.target.innerText)}>
                      {taskListFilter.pageNum+index - pageRange}
                    </span>
                )}
                {(pageEdge === "left"|| pageEdge=== "both" )&&<div className={`
                  ${styles['pagination-line']} 
                  ${pageEdge=="left" && styles['pagination-line-on']}
                  ${pageEdge=="both" && styles['pagination-line-mini']}
                `}></div>
                }
                {(totalPage != 1&&listCount>taskListFilter.itemPerPage)&&
                    <span className={`${styles['pagination-number']} 
                    ${taskListFilter.pageNum == totalPage && 
                    styles['pagination-number-on']}`} onClick={(e)=>{handlePage(e.target.innerText)}}>
                      {totalPage}</span>}
                </>
              }
            </div>
            <button
              className={styles['pagination-next']}
              onClick={handlePageNext}>&gt;
              </button>
          </div>
          }
        </div>
      </div>
  );
}
